import React from 'react';
import GlbHdrUi from 'Views/Glb/GlbHdrUi';
import GlbFtrUi from 'Views/Glb/GlbFtrUi';
import {Outlet} from 'react-router-dom';


const MainLayout = () => {
    return (
        <div className='rootContainer'>
            <GlbHdrUi />
            <Outlet />
            <GlbFtrUi gameSvcCd={"MGP"} gameMainPageData={null}/>
        </div>
    );
  }
  export default MainLayout;